import React from 'react'
import { type Renderer, type CellProps } from 'react-table-next'
import { ListAccountsTruncatableCell } from 'domains/account-management/components/accounts-list/components/cells/ListAccountsTruncatableCell'
import { type EnterpriseAccountDatum } from 'domains/account-management/components/accounts-list/utils/AccountManagementListAccounts.types'
import { useDomainMessage, type DomainMessages } from 'domains/account-management/utils/domain/intl'

export const DefaultCell: Renderer<CellProps<EnterpriseAccountDatum>> = ({ row, column }) => (
  <ListAccountsTruncatableCell>{row.original[column.id] || '—'}</ListAccountsTruncatableCell>
)

export const DefaultHeader: Renderer<CellProps<EnterpriseAccountDatum>> = ({ column }) =>
  useDomainMessage(`accountManagementDomain.list.headers.${column.id}` as DomainMessages)
